program Solicitud;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Menu in 'Menu.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TFMenu, FMenu);
  Application.Run;
end.
